<template>
  <div>
    <material-card :title="title" :color="$vuetify.theme.themes.light.success" icon="add">
      <v-card-text>
        <v-form ref="form" v-model="valid" style="margin-top:10px">
          <v-container>
            <v-row>
              <v-col cols="12" md="6">
                <pbas-date-picker
                  :label="$t('headers.selfpayments.payment_date')"
                  :value="item.PaymentDate"
                  @update-date="item.PaymentDate=$event"
                  :rules="[$rules.required]"
                  :class="'required'"
                ></pbas-date-picker>
              </v-col>
              <v-col cols="12" md="6">
                <trans-select2
                  v-model="item"
                  propertyName="Term"
                  :items="terms"
                  :label="$t('components.plancreationwizard.membereligibility.period')"
                  field="Name"
                  itemValue="Id"
                  :rules="[$rules.required]"
                  class="required"
                  :displayFunc="(item, str) => `${trans2(item, 'FullName')}`"
                ></trans-select2>
              </v-col>
              <v-col cols="12" md="6">
                <currency-textfield
                  v-model="item.Amount"
                  :label="$t('globals.amount')"
                  class="required"
                  :rules="[$rules.requiredNum]"
                />
                <!-- <no-autocomplete-textfield
                  :label="$t('globals.amount')"
                  v-model="item.Amount"
                  :class="'required'"
                  :rules="[$rules.requiredNum, $rules.decimal]"
                  @keydown="currencyKeydown"
                  @keyup="currencyKeyUp"
                  @blur="amountBlur"
                  prefix="$"
                ></no-autocomplete-textfield> -->
              </v-col>
              <v-col cols="12" md="6">
                <v-checkbox
                  :label="$t('headers.selfpayments.deposited')"
                  v-model="item.Deposited"
                ></v-checkbox>
              </v-col>
              <!-- <v-col cols="12" md="6">
                <auto-select
                  :value.sync="item.Category"
                  :label="$t('globals.category')"
                  :items="categories"
                  :rules="[$rules.required]"
                  class="required"
                />
              </v-col> -->
            </v-row>
          </v-container>
        </v-form>
      </v-card-text>
      <v-divider />
      <v-card-actions>
        <v-btn text @click="$emit('close')">{{ $t("globals.cancel") }}</v-btn>
        <v-btn
          :disabled="!valid"
          color="primary"
          :loading="saving"
          @click="save"
        >
          {{ $t("globals.save") }}
        </v-btn>
      </v-card-actions>
    </material-card>
    <error-handler :error="error"></error-handler>
  </div>
</template>

<script>
import { mapActions, mapGetters } from "vuex";
import ErrorHandler from "../components/ErrorHandler";
import AutoSelect from "../components/AutoSelect";
import NoAutocompleteTextfield from "../components/NoAutocompleteTextfield";
import TransSelect from "../components/TransSelect";
import TransSelect2 from "../components/TransSelect2";
import CurrencyTextfield from '../components/CurrencyTextfield.vue';
import { translate2 } from "../trans2";
export default {
  components: {
    ErrorHandler,
    AutoSelect,
    NoAutocompleteTextfield,
    TransSelect,
    TransSelect2,
    CurrencyTextfield
  },
  props: {
    item: {
      default: () => ({
        MemberId: "",
        PlanId: "",
        TermId: "",
        PaymentDate: "",
        Amount: 0.0,
        CreatedAt: "",
        ChangedAt: null,
        DeletedAt: null,
        Deposited: false
      }),
    },
    title: String,
    employerId: String,
    memberIdentityId: String
  },
  data: () => ({
    valid: true,
    error: null,
    saving: false,
    terms: [],
  }),
  computed: {
    ...mapGetters("common", { selectedPlan: "plan" }),
    ...mapGetters("plansMembers", ["options"]),
  },
  watch: {
    "item.PaymentDate": {
      handler(v) {
        if (v !== null && v !== undefined) {
          this.loadEmployerAndTerms(v);
        }
      },
    },
  },
  methods: {
    ...mapActions("plansMembers", [
      "addMemberSelfPayments",
      "updateMemberSelfPayment", "getEmployerContributionTerms",
      "getMemberByEffectiveDate"
    ]),
    trans2(item, property) {
      return translate2(item, property);
    },
    async save() {
      this.error = null;
      this.saving = true;
      try {
        let item = JSON.parse(JSON.stringify(this.item));
        if (item.Term) {
          item.CalendarMonth = item.Term.CalendarMonth;
          item.CalendarYear = item.Term.CalendarYear;
          delete item.Term;
        }
        item.Amount = parseFloat(
          item.Amount
        );//.toFixed(2);
        if (item.Id) {
          delete item["@odata.context"];
          await this.updateMemberSelfPayment({
            planIdentityId: this.selectedPlan.Id,
            memberIdentityId: item.MemberId,
            id: item.Id,
            payload: item,
          });
        } else {
          item.CreatedAt = this.$helpers.nowFormatted();

          await this.addMemberSelfPayments({
            planIdentityId: this.selectedPlan.Id,
            memberIdentityId: item.MemberId,
            payload: item,
          });
        }
        this.$emit("save");
      } catch (e) {
        console.error(e);
        this.error = e;
      } finally {
        this.saving = false;
      }
    },
    async loadEmployerAndTerms(effectiveDate) {
      try {
        this.loading = true;
        this.member = (
          await this.getMemberByEffectiveDate({
            planIdentityId: this.selectedPlan.Id,
            memberIdentityId: this.memberIdentityId,
            effectiveDate: effectiveDate,
            odataQuery:
              "$select=Id,&$expand=CurrentMember($select=DateOfBirth),CurrentEmploymentInformation($select=EmployerId,HireDate),CurrentMembershipStatus($select=MemberGroupIdentityId)",
          })
        ).data;
        let employerId = this.member.CurrentEmploymentInformation.EmployerId;
        let terms = (
          await this.getEmployerContributionTerms({
            planIdentityId: this.selectedPlan.Id,
            employerId: employerId,
          })
        ).data.value;
        this.terms = terms.filter(
          (value, index, self) =>
            index ===
            self.findIndex(
              (t) =>
                t.CalendarMonth === value.CalendarMonth &&
                t.CalendarYear === value.CalendarYear
            )
        );
        if (
          this.item.CalendarYear !== null &&
          this.item.CalendarYear !== undefined &&
          this.item.CalendarMonth !== null &&
          this.item.CalendarMonth !== undefined
        ) {
          let term = this.terms.filter(
            (o) =>
              o.CalendarYear === this.item.CalendarYear &&
              o.CalendarMonth === this.item.CalendarMonth
          );
          console.log(term);
          if (term.length > 0) {
            this.item.Term = term[0];
          }
        }
      } catch (error) {
        this.error = error;
      } finally {
        this.loading = false;
      }
    },
  },
  async mounted() {
    // try {
    //   this.loading = true;
    //   this.terms = (await this.getBillingTerms2({
    //     planIdentityId: this.selectedPlan.Id,
    //     employerId: this.employerId,
    //   })).data.value;
    // } catch (error) {
    //   this.error = error;
    // } finally {
    //   this.loading = false;
    // }
  },
};
</script>
